import httpService from '@/services/httpService';
import ApiEndpoints from '@/utils/ApiEndpoints';

export default {
    getSourceCategories () {
        return httpService.get(ApiEndpoints.get('source_categories'));
    },
    getReportersCategories () {
        return httpService.get(ApiEndpoints.get('reporter_categories'));
    },
    getHelpCriteria () {
        return httpService.get(ApiEndpoints.get('help_categories'));
    },
    getVolunteerRefusalReason () {
        return httpService.get(ApiEndpoints.get('volunteer_refusal_reason'));
    },
    getTurnOffReasons () {
        return httpService.get(ApiEndpoints.get('turn_off_reasons'));
    },
    getAvailableWioStructs () {
        return httpService.get(ApiEndpoints.get('available_wio_structs'));
    },
    getWioStructInfo (id, params = null) {
        return httpService.get(ApiEndpoints.get('wio_struct_information', { wioStructId: id }), {
            params
        });
    },
    getNoVolunteersTurnOffReasons () {
        return httpService.get(ApiEndpoints.get('turn_off_reasons_no_volunteer'));
    },
    getFamilyVolunteers (id) {
        return httpService.get(ApiEndpoints.get('family_volunteers', { familyEditionId: id }));
    },
    getProvincesForFamiliesToAccept () {
        return httpService.get(ApiEndpoints.get('provinces_for_family_to_accept'));
    }
};
